exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-image-section[data-v-c8b677d0] {\n    min-height: 10rem;\n    max-height: 13rem;\n}\n.card-image-container[data-v-c8b677d0] {\n    max-height: inherit;\n    max-width: 100%;\n}\n.card-image[data-v-c8b677d0] {\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n    max-height: inherit;\n    max-width: inherit;\n}\n", ""]);

// exports
